// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import { useDispatch } from "react-redux";
// import { updateProfleAction } from "../../../redux/actions/user/userAction";
// import { connect } from "react-redux";
// import { labelGroupedOptions } from "../helper/index";
// import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
// import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

// export const StatutoryIndustryTraining = (props) => {

//   const customStyles = {
//     control: (base, state) => ({
//       ...base,
//       top: "5px",
//       // Overwrittes the different states of border
//       borderColor: state.isFocused ? "#309CCA" : "#309CCA",
//     }),
//   };

//   const MAX_ENTRIES = 5; // ⭐ Max number of entries

//   const dispatch = useDispatch();
//   const [valueSelected, setValueSelected] = useState([]);
//   const [groupedOptions, setGroupedOptions] = useState([]);
//   const [inputData, setInputData] = useState([]);
//   const [statutoryIndustry, setStatutoryIndustry] = useState([{}]);
//   const [isEnable, setIsEnable] = useState({ save: false });
//   const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
//     useState(false);
//   const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
//     useNavigatingAway(canShowDialogLeavingPage);

//   const handleAddFormChange = () => {
//     setStatutoryIndustry((prevState) => [...prevState, null]);
//   };

//   const handleChange = (event, index) => {
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: true,
//     }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...statutoryIndustry];
//     values[index] = event["id"];
//     setStatutoryIndustry(values);
//   };

//   const handleFormSubmit = (event) => {
//     event.preventDefault();
//     const statutoryIndustryTraining = {
//       userId: inputData.userId,
//       statutory_industry: statutoryIndustry,
//     };
//     dispatch(updateProfleAction(inputData.userId, statutoryIndustryTraining));
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: false,
//     }));
//     setCanShowDialogLeavingPage(false);
//   };

//   const handleRemoveFormChange = (index) => {
//     setIsEnable((prevState) => ({
//       ...prevState,
//       save: true,
//     }));
//     setCanShowDialogLeavingPage(true);
//     const values = [...statutoryIndustry];
//     values.splice(index, 1);
//     setStatutoryIndustry(values);
//   };

//   useEffect(() => {
//     if (Object.keys(props.profile).length > 0) {
//       const statutory = { userId: props.profile.userId };
//       setInputData(statutory);
//       setStatutoryIndustry(
//         props.profile.statutory_industry &&
//           props.profile.statutory_industry.length === 0
//           ? [null]
//           : props.profile.statutory_industry
//       );
//     }

//     if (props.statutoryIndustry.length > 0 && props.sector.length > 0) {
//       const statutoryIndustryTraining = props.statutoryIndustry.filter((val) =>
//         [props.primarySectorId, props.secondarySectorId].includes(val["sector"])
//       );

//       setValueSelected(statutoryIndustryTraining);
//       const options = labelGroupedOptions(
//         statutoryIndustryTraining,
//         "sector",
//         props.sector
//       );
//       setGroupedOptions(options);
//     }
//   }, [props]);

//   return (
//     <div className="row margin-row">
//       <DialogLeavingPage
//         showDialog={showDialogLeavingPage}
//         setShowDialog={setCanShowDialogLeavingPage}
//         confirmNavigation={confirmNavigation}
//         cancelNavigation={cancelNavigation}
//         title={"Statutory & Industry Training"}
//       />
//       <div className="col-12  ">
//         <div className="timeline-border-box">
//           <h5>Statutory & Industry Training</h5>

//           <div className="row">
//             {statutoryIndustry &&
//               statutoryIndustry.map((statutory_training, index) => {
//                 return (
//                   <div className="col-12 parent-col" key={index}>
//                     <div className="row cloneRowTarget">
//                       <div
//                         className="col-md-6 col-12"
//                         style={{ paddingTop: "2%" }}
//                       >
//                         <label className="field-label">Training / Course</label>
//                       </div>
//                       <div
//                         className="col-md-5 col-10"
//                         style={{ paddingTop: "1%" }}
//                       >
//                         <Select
//                           id="statutoryIndustryTraining"
//                           name="statutoryIndustryTraining"
//                           value={
//                             valueSelected &&
//                             valueSelected.find(
//                               (row) => row.id === statutory_training
//                             )
//                               ? valueSelected.find(
//                                   (row) => row.id === statutory_training
//                                 )
//                               : null
//                           }
//                           options={groupedOptions}
//                           getOptionLabel={(option) => option.statutory_training}
//                           getOptionValue={(option) => option.id}
//                           onChange={(event) => handleChange(event, index)}
//                           placeholder="Choose.."
//                           isClearable={true}
//                           styles={customStyles}
//                           isOptionDisabled={(option) =>
//                             statutoryIndustry.includes(option.id)
//                           }
//                         />
//                       </div>
//                       {index !== 0 ? (
//                         <div className="col-md-1 col-12 text-right clone-row-btn-holder">
//                           <Link
//                             to=""
//                             style={{ cursor: "pointer" }}
//                             onClick={() => handleRemoveFormChange(index)}
//                             className="cloneTargetTrigger"
//                           >
//                             -
//                           </Link>
//                         </div>
//                       ) : (
//                         <></>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             <div className="col-12 text-right clone-row-btn-holder">
//               <Link
//                 to=""
//                 style={{ cursor: "pointer" }}
//                 onClick={handleAddFormChange}
//                 className="cloneTargetTrigger"
//               >
//                 +
//               </Link>
//             </div>
//           </div>
//           <br />
//           <div className="col text-right ">
//             {isEnable.save ? (
//               <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
//                 <span>
//                   <img src="/assets/images/icons/save.png" alt="" />Save
//                 </span>
//               </Link>
//             ) : (
//               ""
//             )}{" "}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   const profile = state.user.profile;
//   const statutoryIndustry = state.admin.statutoryIndustry;
//   const sector = state.admin.sector;

//   return {
//     profile: profile,
//     statutoryIndustry: statutoryIndustry,
//     sector: sector,
//   };
// };
// const mapDispatchToProps = {};

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(StatutoryIndustryTraining);



///////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { labelGroupedOptions } from "../helper/index";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const StatutoryIndustryTraining = (props) => {

  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const MAX_ENTRIES = 5; // Max number of entries

  const dispatch = useDispatch();
  const [valueSelected, setValueSelected] = useState([]);
  const [groupedOptions, setGroupedOptions] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [statutoryIndustry, setStatutoryIndustry] = useState([{}]);
  const [isEnable, setIsEnable] = useState({ save: false });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleAddFormChange = () => {
    // Enforce max 5 entries
    if (statutoryIndustry.length >= MAX_ENTRIES) {
      alert(`You can add up to ${MAX_ENTRIES} entries only.`);
      return;
    }

    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    setStatutoryIndustry((prevState) => [...prevState, null]);
  };

  const handleChange = (event, index) => {
    setIsEnable((prevState) => ({
      ...prevState,
      save: true,
    }));
    setCanShowDialogLeavingPage(true);
    const values = [...statutoryIndustry];
    values[index] = event["id"];
    setStatutoryIndustry(values);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const statutoryIndustryTraining = {
      userId: inputData.userId,
      statutory_industry: statutoryIndustry,
    };
    dispatch(updateProfleAction(inputData.userId, statutoryIndustryTraining));
    setIsEnable((prevState) => ({
      ...prevState,
      save: false,
    }));
    setCanShowDialogLeavingPage(false);
  };

  const handleRemoveFormChange = (index) => {
    setIsEnable((prevState) => ({
      ...prevState,
      save: true,
    }));
    setCanShowDialogLeavingPage(true);
    const values = [...statutoryIndustry];
    values.splice(index, 1);
    setStatutoryIndustry(values);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const statutory = { userId: props.profile.userId };
      setInputData(statutory);
      setStatutoryIndustry(
        props.profile.statutory_industry &&
          props.profile.statutory_industry.length === 0
          ? [null]
          : props.profile.statutory_industry
      );
    }

    if (props.statutoryIndustry.length > 0 && props.sector.length > 0) {
      const statutoryIndustryTraining = props.statutoryIndustry.filter((val) =>
        [props.primarySectorId, props.secondarySectorId].includes(val["sector"])
      );

      setValueSelected(statutoryIndustryTraining);
      const options = labelGroupedOptions(
        statutoryIndustryTraining,
        "sector",
        props.sector
      );
      setGroupedOptions(options);
    }
  }, [props]);

  // Remaining entries for UI
  const remaining =
    MAX_ENTRIES -
    (statutoryIndustry && statutoryIndustry.length
      ? statutoryIndustry.length
      : 0);

  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Statutory & Industry Training"}
      />
      <div className="col-12  ">
        <div className="timeline-border-box">
          <h5>Statutory & Industry Training</h5>

          <div className="row">
            {statutoryIndustry &&
              statutoryIndustry.map((statutory_training, index) => {
                return (
                  <div className="col-12 parent-col" key={index}>
                    <div className="row cloneRowTarget">
                      <div
                        className="col-md-6 col-12"
                        style={{ paddingTop: "2%" }}
                      >
                        <label className="field-label">Training / Course</label>
                      </div>
                      <div
                        className="col-md-5 col-10"
                        style={{ paddingTop: "1%" }}
                      >
                        <Select
                          id="statutoryIndustryTraining"
                          name="statutoryIndustryTraining"
                          value={
                            valueSelected &&
                            valueSelected.find(
                              (row) => row.id === statutory_training
                            )
                              ? valueSelected.find(
                                  (row) => row.id === statutory_training
                                )
                              : null
                          }
                          options={groupedOptions}
                          getOptionLabel={(option) => option.statutory_training}
                          getOptionValue={(option) => option.id}
                          onChange={(event) => handleChange(event, index)}
                          placeholder="Choose.."
                          isClearable={true}
                          styles={customStyles}
                          isOptionDisabled={(option) =>
                            statutoryIndustry.includes(option.id)
                          }
                        />
                      </div>
                      {index !== 0 ? (
                        <div className="col-md-1 col-12 text-right clone-row-btn-holder">
                          <Link
                            to=""
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRemoveFormChange(index)}
                            className="cloneTargetTrigger"
                          >
                            -
                          </Link>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                );
              })}
            {/* Show + button only if under limit */}
            {remaining > 0 && (
              <div className="col-12 text-right clone-row-btn-holder">
                <Link
                  to=""
                  style={{ cursor: "pointer" }}
                  onClick={handleAddFormChange}
                  className="cloneTargetTrigger"
                >
                  +
                </Link>
              </div>
            )}
          </div>
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}{" "}
            <p
              style={{
                fontSize: "12px",
                textAlign: "left",
                color:  "#555" // red when max reached
              }}
            >
              {remaining > 0
                ? `${remaining} remaining`
                : "Maximum number of courses added."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const profile = state.user.profile;
  const statutoryIndustry = state.admin.statutoryIndustry;
  const sector = state.admin.sector;

  return {
    profile: profile,
    statutoryIndustry: statutoryIndustry,
    sector: sector,
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatutoryIndustryTraining);

